import Photo2 from '../.././assets/photo2.jpg';
import Photo3 from '../.././assets/carousel-home/2023-07-16 14_52_53.742+0800.jpg';
import CustomMargin from '../../components/custom-margin';
import CareerCard from './components/career-card';
import SEO from '../../components/seo';

export default function Careers(){
    return(
        <div className="min-h-screen bg-[#090909] text-zinc-300"><CustomMargin>
            <SEO
                title="Careers | Quilaton Law Office"
                description="Explore career opportunities at Quilaton Law Office in Cebu City, Philippines."
                path="/careers/"
            />
            <div className='flex flex-col items-center justify-center px-5 py-14'>
                {/* <div className='w-auto gap-2 sm:hidden lg:flex'>
                    <img alt='QLO' src={Photo3} className='w-1/2'/>
                    <img alt='QLO' src={Photo2} className='w-1/2'/>
                </div>
                <p className='text-2xl font-fontMontserrat'>We are looking for dedicated, development-oriented, performance-based, pro-active, and solutions-focused individuals who have the grit and passion to serve the people through the legal services that we offer.</p> */}
                {/* <p className='p-5'>NO CAREERS ARE CURRENTLY OFFERED AS OF THE MOMENT.</p> */}
                <CareerCard 
                    jobTitle={"Paralegal"}
                    jobDescription={"We are looking for a detail-oriented and proactive Paralegal Intern or Legal Assistant to support our legal team. The ideal candidate is currently pursuing a law degree or holds a background in fields related to law and administration. This role offers hands-on experience in legal processes, research, and documentation, making it a valuable opportunity for those looking to build a career in the legal field."}
                    datePosted={'Sunday, April 13, 2025'}
                    facebookLink={'https://www.facebook.com/photo/?fbid=675304798582465&set=a.127148710064746'}
                />
            </div>
        </CustomMargin></div>
    );
}
